import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import Layout, { SecondaryCTA } from '@pcid/components/layout';
import Link from '@pcid/link';
import track from '@pcid/analytics/track';
import { AutoFormattedMessage } from '@pcid/string-utils';
import { localeCodes } from '@pcid/locale-utils';
import { withLocale } from '@pcid/components/locale-provider';
import { handleHousekeeping, getInitialStatus } from '@pcid/utils/form-utils';
import { getEmailStorage } from '@pcid/storage-utils';
import withTarget from '@pcid/components/with-target';
import Sprite from '@pcid/sprite';
import ForgotPasswordForm from '../components/forms/forgotPasswordForm';
import processForgotPassword from '../actions/forgot-password';
import constants from '../actions/track-analytics/constants';

const { linkName: { BACK_TO_SIGN_IN } } = constants;

class ForgotPassword extends React.Component {
	state = {
		submitDisabled: false,
		convergenceBanner: '',
	}

	componentDidMount() {
		const { locale, target } = this.props;
		const convergenceBanner = (
			<div className="login-form__convergence-banner">
				<div className="login-form__convergence-banner-logo-container">
					<Sprite
						group="banners"
						symbol={`pc-id_${locale}`}
						alt="PCid Logo"
						className="layout__pcid-logo-banner"
					/>
				</div>
				<AutoFormattedMessage
					id="form.createAccount.description1"
				/>
				<hr className="login-form__divider" />
				<Sprite
					group="banner"
					symbol={`banner-optimum_${locale}`}
					className="login-form__convergence-banner-svg"
				/>
				<Sprite
					group="banner"
					symbol={`banner-express_${locale}`}
					className="login-form__convergence-banner-svg"
				/>
				<Sprite
					group="banner"
					symbol={`banner-health_${locale}`}
					className="login-form__convergence-banner-svg"
				/>
				<span className="login-form__last-two-svg-group">
					<Sprite
						group="banner"
						symbol={`banner-shoppers_${locale}`}
						className="login-form__convergence-banner-svg"
					/>
					<Sprite
						group="banner"
						symbol="banner-joe-fresh"
						className="login-form__convergence-banner-svg login-form__last-svg"
					/>
				</span>
			</div>
		);
		this.setState({ convergenceBanner });

		target.applyOffers();
	}

	setSubmitDisabled = (submitDisabled) => {
		this.setState({ submitDisabled });
	}

	render() {
		const { submitDisabled, convergenceBanner } = this.state;
		return (
			<Layout
				title="page.title.forgotPassword"
				className="forgot-password-page"
				convergenceBanner={convergenceBanner}
				convergenceBannerPosition="top"
			>
				<Formik
					render={(formikProps) => (
						<ForgotPasswordForm
							{...formikProps}
							isSubmitDisabled={submitDisabled}
							setSubmitDisabled={this.setSubmitDisabled}
						/>
					)}
					initialValues={{ email: getEmailStorage().get() || '' }}
					initialStatus={getInitialStatus()}
					onSubmit={handleHousekeeping((data) => {
						this.setSubmitDisabled(true);
						return processForgotPassword(data);
					})}
				/>
				<SecondaryCTA>
					<Link
						to="/login?hidePageView=true"
						onClick={() => {
							track.customLink({ linkName: BACK_TO_SIGN_IN });
						}}
					>
						<AutoFormattedMessage id="common.backToSignIn" />
					</Link>
				</SecondaryCTA>
			</Layout>
		);
	}
}

ForgotPassword.propTypes = {
	locale: PropTypes.string,
	target: PropTypes.object.isRequired,
};

ForgotPassword.defaultProps = {
	locale: localeCodes.EN,
};

export default withLocale(withTarget(ForgotPassword));
